import { render, staticRenderFns } from "./ItemInfoStrip.vue?vue&type=template&id=0326ff78&scoped=true"
import script from "./ItemInfoStrip.vue?vue&type=script&lang=js"
export * from "./ItemInfoStrip.vue?vue&type=script&lang=js"
import style0 from "./ItemInfoStrip.vue?vue&type=style&index=0&id=0326ff78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326ff78",
  null
  
)

export default component.exports